"use client";
import { useProducts } from "@/features/products/ProductListingPage/ListingContext";

import type React from "react";

export const DisplayProductsOrNoResults = ({
    productList,
    noResults,
}: {
    productList: React.ReactNode;
    noResults?: React.ReactNode;
}) => {
    const { total, isLoading } = useProducts();

    if (isLoading) return productList;

    return <>{total > 0 ? productList : noResults}</>;
};